import { render, staticRenderFns } from "./issue-add-dialog.vue?vue&type=template&id=60ae9509&lang=pug&"
import script from "./issue-add-dialog.vue?vue&type=script&lang=ts&"
export * from "./issue-add-dialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports